import React from "react";
import {
  Container,
  HeaderSection,
  Title,
  LastUpdated,
  Content,
  Section,
  SectionTitle,
  SectionContent,
  List,
  ListItem,
  ContactBox,
  ContactLink,
} from "./PrivacyPolicy.style";

export default function PrivacyPolicy() {
  React.useEffect(() => {
    document.title = "Privacy Policy — TrixieGroup & Association";
    window.scrollTo(0, 0);
  }, []);

  return (
    <Container>
      <HeaderSection>
        <Title>Privacy Policy</Title>
        <LastUpdated>Last Updated: April 2, 2026</LastUpdated>
      </HeaderSection>

      <Content>
        <Section>
          <SectionTitle>1. Introduction</SectionTitle>
          <SectionContent>
            TrixieGroup & Association ("we," "our," or "us") is committed to protecting
            your privacy. This Privacy Policy explains how we collect, use, disclose,
            and safeguard your information when you visit our website or use our services.
            Please read this privacy policy carefully. If you do not agree with the terms
            of this privacy policy, please do not access the site.
          </SectionContent>
        </Section>

        <Section>
          <SectionTitle>2. Information We Collect</SectionTitle>
          <SectionContent>
            We may collect information about you in a variety of ways. The information
            we may collect on the Site includes:
          </SectionContent>
          <List>
            <ListItem>
              <strong>Personal Data:</strong> Personally identifiable information, such as your
              name, email address, and telephone number that you voluntarily give to us
              when you contact us or fill out forms on the Site.
            </ListItem>
            <ListItem>
              <strong>Usage Data:</strong> Information our servers automatically collect when
              you access the Site, such as your IP address, browser type, operating system,
              access times, and the pages you have viewed directly before and after accessing
              the Site.
            </ListItem>
            <ListItem>
              <strong>Cookies:</strong> We may use cookies, web beacons, tracking pixels, and
              other tracking technologies on the Site to help customize the Site and improve
              your experience.
            </ListItem>
          </List>
        </Section>

        <Section>
          <SectionTitle>3. How We Use Your Information</SectionTitle>
          <SectionContent>
            Having accurate information about you permits us to provide you with a smooth,
            efficient, and customized experience. Specifically, we may use information collected
            about you via the Site to:
          </SectionContent>
          <List>
            <ListItem>Respond to your inquiries and communicate with you</ListItem>
            <ListItem>Process and fulfill your service requests</ListItem>
            <ListItem>Send you marketing and promotional communications</ListItem>
            <ListItem>Improve our website and services</ListItem>
            <ListItem>Prevent fraudulent transactions and protect against criminal activity</ListItem>
            <ListItem>Compile anonymous statistical data for internal use</ListItem>
          </List>
        </Section>

        <Section>
          <SectionTitle>4. Disclosure of Your Information</SectionTitle>
          <SectionContent>
            We may share information we have collected about you in certain situations.
            Your information may be disclosed as follows:
          </SectionContent>
          <List>
            <ListItem>
              <strong>By Law or to Protect Rights:</strong> If we believe the release of
              information about you is necessary to respond to legal process, to investigate
              or remedy potential violations of our policies, or to protect the rights,
              property, and safety of others.
            </ListItem>
            <ListItem>
              <strong>Service Providers:</strong> We may share your information with third
              parties that perform services for us or on our behalf, including payment
              processing, data analysis, email delivery, hosting services, and customer service.
            </ListItem>
            <ListItem>
              <strong>Business Transfers:</strong> We may share or transfer your information
              in connection with, or during negotiations of, any merger, sale of company
              assets, financing, or acquisition of all or a portion of our business.
            </ListItem>
          </List>
        </Section>

        <Section>
          <SectionTitle>5. Security of Your Information</SectionTitle>
          <SectionContent>
            We use administrative, technical, and physical security measures to help protect
            your personal information. While we have taken reasonable steps to secure the
            personal information you provide to us, please be aware that despite our efforts,
            no security measures are perfect or impenetrable, and no method of data
            transmission can be guaranteed against any interception or other type of misuse.
          </SectionContent>
        </Section>

        <Section>
          <SectionTitle>6. Your Rights</SectionTitle>
          <SectionContent>
            You have the right to:
          </SectionContent>
          <List>
            <ListItem>Request access to the personal data we hold about you</ListItem>
            <ListItem>Request correction of any inaccurate or incomplete data</ListItem>
            <ListItem>Request deletion of your personal data</ListItem>
            <ListItem>Object to the processing of your personal data</ListItem>
            <ListItem>Request restriction of processing of your personal data</ListItem>
          </List>
        </Section>

        <Section>
          <SectionTitle>7. Changes to This Privacy Policy</SectionTitle>
          <SectionContent>
            We may update this Privacy Policy from time to time in order to reflect changes
            to our practices or for other operational, legal, or regulatory reasons. Any
            changes will be effective immediately upon posting the updated Privacy Policy
            on the Site, and we will notify you of any material changes by posting a notice
            on our Site.
          </SectionContent>
        </Section>

        <Section>
          <SectionTitle>8. Contact Us</SectionTitle>
          <SectionContent>
            If you have questions or comments about this Privacy Policy, please contact us:
          </SectionContent>
          <ContactBox>
            <p><strong>TrixieGroup & Association</strong></p>
            <p>Ise Eledumare Shopping Complex,<br />Okebola off Iyana Ogunpa Road, Ibadan, Nigeria</p>
            <ContactLink href="tel:+2348034231676">+234 803 423 1676</ContactLink>
            <ContactLink href="mailto:info@trixiegroup.com">info@trixiegroup.com</ContactLink>
          </ContactBox>
        </Section>
      </Content>
    </Container>
  );
}
